import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
import { ListChecksIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { Route as pathlessAuthenticatedRoute } from '../../route';
import { ItemListsPage } from './ItemListsPage';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/item-master/lists',
  staticData: {
    app: {
      nav: {
        label: msg('Lists', {
          context: 'sidebar nav label, Item Master section',
        }),
        icon: <ListChecksIcon className="h-4 w-4" weight="fill" />,
        group: 'Item Master',
        order: 15,
        groupOrder: 27,
      },
      access: {
        featureFlag: 'item-master-ui-enabled',
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Product }],
      },
    },
  },
  component: ItemListsPage,
  loader: () => ({
    crumb: msg('Lists', { context: 'page breadcrumb' }),
  }),
});
